import React, { useEffect, useState } from "react";
import parse from "html-react-parser";
import cn from "classnames";

import {
    EnrollStep,
    EnrollStepData,
    StepStatus,
} from "store/environments/tenants/enroll-tenant/enroll-tenant-types";

import cssError from "./AutomatedStepErrorSection/AutomatedStepErrorSection.module.css";
import css from "./AutomatedStep.module.css";

interface Props {
    activeStep: EnrollStep | null;
}

const AutomatedStep: React.FC<Props> = ({ activeStep }: Props) => {
    const [messageList, setMessageList] = useState<EnrollStepData[]>([]);

    const getMessages = (activeStep: EnrollStep): [] => {
        try {
            return JSON.parse(activeStep.data || "") || [];
        } catch {
            return [];
        }
    };

    const getMessageElement = (
        activeStep: EnrollStep | null,
        message: EnrollStepData | null | undefined,
        messageList: EnrollStepData[]
    ) => {
        try {
            if (!message) {
                return <></>;
            }

            const msgIndex = messageList.findIndex((m) => m === message);
            const currentMessage = message.actionMessage
                ? parse(message.actionMessage)
                : parse(message.actionDescription);
            const isActionRunning =
                message.actionMessage !== null &&
                (message === messageList[messageList.length - 1] ||
                    messageList[msgIndex + 1]?.actionMessage === null);

            if (
                (activeStep?.status === StepStatus.Failed ||
                    activeStep?.status === StepStatus.Skipped) &&
                isActionRunning
            ) {
                return (
                    <div className={cn(css.failedElement, css.listElement)}>
                        {currentMessage}
                        {activeStep?.logs && (
                            <p className={cssError.errorSection}>
                                {activeStep.logs}
                            </p>
                        )}
                    </div>
                );
            }

            if (activeStep?.status === StepStatus.Running && isActionRunning) {
                return (
                    <div className={cn(css.inProgressElement, css.listElement)}>
                        {currentMessage}
                    </div>
                );
            }

            if (message.actionMessage == null) {
                return (
                    <div className={cn(css.pendingElement, css.listElement)}>
                        {currentMessage}
                    </div>
                );
            }

            return <div className={css.listElement}>{currentMessage}</div>;
        } catch (e) {
            return <>{String(e)}</>;
        }
    };

    useEffect(() => {
        if (activeStep !== null) {
            setMessageList(getMessages(activeStep));
        }
    }, [activeStep]);

    return (
        <div>
            <ul className={css.list}>
                {messageList.map((message: EnrollStepData, index: number) => (
                    <li key={index}>
                        {getMessageElement(activeStep, message, messageList)}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default AutomatedStep;
